import { render, staticRenderFns } from "./alarmType.vue?vue&type=template&id=a4d51496&scoped=true&"
import script from "./alarmType.vue?vue&type=script&lang=js&"
export * from "./alarmType.vue?vue&type=script&lang=js&"
import style0 from "./alarmType.vue?vue&type=style&index=0&id=a4d51496&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4d51496",
  null
  
)

export default component.exports